export default __webpack_public_path__ + "static/media/React__1.0e92da4a.png";